export default __webpack_public_path__ + "static/media/multiple.b457413d.svg";